import { wixColorParam } from '@wix/tpa-settings/dist/src/getWixColor';
import { wixFontParam } from '@wix/tpa-settings/dist/src/getWixFont';
import { StyleParamType } from '@wix/tpa-settings/dist/src/contexts/StylesContext/StylesContext.types';

import {
  TextSettings,
  AboutDisplaySettings,
  MembersDisplaySettings,
  MediaDisplaySettings,
  DiscussionsDisplaySettings,
  MediaLayoutSettings,
  MediaLayout,
  CoverImageLayout,
  GeneralLayoutSettings,
  LayoutStyles,
  DesignStyles,
  DesignSettings,
  ButtonType,
} from './types';

export const layoutStyles: LayoutStyles = {
  general: {
    coverImageFullWidth: {
      getDefaultValue: () => false,
      name: 'coverImageFullWidth',
      type: StyleParamType.Boolean,
    },
    coverImageHeight: {
      getDefaultValue: () => 240,
      name: 'coverImageHeight',
      type: StyleParamType.Number,
    },
    layoutSpacing: {
      getDefaultValue: () => 20,
      name: 'layoutSpacing',
      type: StyleParamType.Number,
    },
  },
};

export const designStyles: DesignStyles = {
  header: {
    groupTitle: {
      color: {
        name: 'groupTitleColor',
        type: StyleParamType.Color,
        getDefaultValue: wixColorParam('color-5'),
      },
      font: {
        name: 'groupTitleFont',
        type: StyleParamType.Font,
        getDefaultValue: wixFontParam('Heading-XL'),
      },
    },
    groupSubTitle: {
      color: {
        name: 'groupSubtitleColor',
        type: StyleParamType.Color,
        getDefaultValue: wixColorParam('color-5', 0.6),
      },
      font: {
        name: 'groupSubtitleFont',
        type: StyleParamType.Font,
        getDefaultValue: wixFontParam('Body-M'),
      },
    },
    tabs: {
      color: {
        name: 'tabsColor',
        type: StyleParamType.Color,
        getDefaultValue: wixColorParam('color-5'),
      },
      font: {
        name: 'tabsFont',
        type: StyleParamType.Font,
        getDefaultValue: wixFontParam('Body-M'),
      },
    },
  },
  posts: {
    background: {
      color: {
        name: 'postsBackgroundColor',
        type: StyleParamType.Color,
        getDefaultValue: wixColorParam('color-1'),
      },
    },
    border: {
      color: {
        name: 'postsBorderColor',
        type: StyleParamType.Color,
        getDefaultValue: wixColorParam('color-5', 0.6),
      },
      width: {
        name: 'postsBorderWidth',
        type: StyleParamType.Number,
        getDefaultValue: () => 1,
      },
    },
    text: {
      color: {
        name: 'postsTextColor',
        type: StyleParamType.Color,
        getDefaultValue: wixColorParam('color-5'),
      },
      font: {
        name: 'postsTextFont',
        type: StyleParamType.Font,
        getDefaultValue: wixFontParam('Body-M'),
      },
    },
  },
  buttons: {
    text: {
      color: {
        name: 'buttonsTextColor',
        type: StyleParamType.Color,
        getDefaultValue: wixColorParam('color-1'),
      },
      font: {
        name: 'buttonsTextFont',
        type: StyleParamType.Font,
        getDefaultValue: wixFontParam('Body-L'),
      },
    },
    color: {
      name: 'buttonsColor',
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-8'),
    },
    radius: {
      name: 'buttonsColor',
      type: StyleParamType.Number,
      getDefaultValue: () => 100,
    },
  },
  overlay: {
    color: {
      name: 'overlayColor',
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-5', 0.6),
    },
    icon: {
      color: {
        name: 'iconOverlayColor',
        type: StyleParamType.Color,
        getDefaultValue: wixColorParam('color-1'),
      },
    },
  },
  app: {
    background: {
      color: {
        name: 'appBackgroundColor',
        type: StyleParamType.Color,
        getDefaultValue: wixColorParam('color-1'),
      },
    },
  },
};

export const designSettings: DesignSettings = {
  buttonType: {
    key: 'buttonType',
    getDefaultValue: () => ButtonType.rectangle,
  },
};

export const generalLayoutSettings: GeneralLayoutSettings = {
  coverImageFullWidth: {
    getDefaultValue: () => true,
    key: 'coverImageFullWidth',
  },
  coverImageHeight: {
    getDefaultValue: () => 240,
    key: 'coverImageHeight',
  },
  layoutSpacing: {
    getDefaultValue: () => 20,
    key: 'layoutSpacing',
  },
  coverImageLayout: {
    getDefaultValue: () => CoverImageLayout.large,
    key: 'coverImageLayout',
  },
};

export const mediaLayoutSettings: MediaLayoutSettings = {
  imagesPerRow: {
    getDefaultValue: () => 5,
    key: 'imagesPerRow',
  },
  mediaLayout: {
    getDefaultValue: () => MediaLayout.grid,
    key: 'mediaLayout',
  },
};

export const discussionsDisplaySettings: DiscussionsDisplaySettings = {
  showBreadcrumbs: {
    key: 'showBreadcrumbs',
    getDefaultValue: () => false,
  },
  showMembersCount: {
    key: 'showMembersCount',
    getDefaultValue: () => true,
  },
  showReactions: {
    key: 'showReactions',
    getDefaultValue: () => true,
  },
  showShareButton: {
    key: 'showShareButton',
    getDefaultValue: () => false,
  },
};

export const mediaDisplaySettings: MediaDisplaySettings = {
  showNameOnHover: {
    key: 'showNameOnHover',
    getDefaultValue: () => true,
  },
};

export const membersDisplaySettings: MembersDisplaySettings = {
  showContent: {
    key: 'showContent',
    getDefaultValue: () => false,
  },
  showFilters: {
    key: 'showFilters',
    getDefaultValue: () => false,
  },
  showFollowButton: {
    key: 'showFollowButton',
    getDefaultValue: () => false,
  },
};

export const aboutDisplaySettings: AboutDisplaySettings = {
  showActivity: {
    getDefaultValue: () => true,
    key: 'showActivity',
  },
};

export const textSettings: TextSettings = {
  newPostBoxLabel: {
    getDefaultValue: () => '',
    key: 'newPostBoxLabel',
  },
};
